import axios from 'axios';
import {apiServerHost} from '../../common/APIServerSettings';

const updateCondition = (callBackFunc, responseID, mapperID, conditionText) => {
  const params = new URLSearchParams();
  params.append("responseID", responseID);
  params.append("mapperID", responseID);
  params.append("condition", conditionText);
  axios.post(apiServerHost + "/manage/topic/builder/update/response/condition", params)
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  });
}

const createCondition = (callBackFunc, responseID, conditionText) => {
  const params = new URLSearchParams();
  params.append("responseID", responseID);
  params.append("condition", conditionText);
  axios.post(apiServerHost + "/manage/topic/builder/create/condition", params)
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  });
}

export {updateCondition};
export {createCondition};